import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {User} from './../../../models/user.model';
import {Address} from './../../../models/address.model';
import { UserService2 } from './../../../services/user2.service';
import {MyobContact} from './../../../models/myob-contacts.model';
import {MyobContactService} from './../../../services/myob-contact.service';
import { DemoService } from './../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Location} from '@angular/common';
import { MysqlService } from './../../../services/mysql.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { BsModalService } from 'ngx-bootstrap';
import { Observable } from 'rxjs';

import { GlobalFunctionsService } from './../../../services/global-functions.service';


// :: @source https://nehalist.io/angular-7-models/ (user models tutorial)
@Component({
  selector: 'app-myob-customers',
  templateUrl: './myob-customers.component.html',
  styleUrls: ['./myob-customers.component.css'],
  providers: [UserService2]
})
export class MyobCustomersComponent implements OnInit{

  public userId: number;
  public user: User;
  public users: User[];


  public UID: any = '2ec42162-cfe7-4253-ada4-b4c09bcb7e0d';
  public myobContact: MyobContact;
  public myobContacts: MyobContact[];
  public addresses: Address[];
  myobContacts_demo: any;
  myobCode: Object;
  myobCustomersDemo: Object;
  arrCase: object[];
  Items: any;
  myobCustomer: Object;
  customerItem: any;

  // Many
  public myobContactsListMapped: MyobContact[];
  // single
  public myobContactListMapped: MyobContact[];

  constructor( private userService2: UserService2 , private myobContactService: MyobContactService,
    private _mysqlService: MysqlService,
    private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient,
      private _demoService: DemoService,
      public toastr: HotToastService,
      private modalService: BsModalService, public gfunc: GlobalFunctionsService,
      private _location: Location ) {
   
  }

ngOnInit(){
  // :: This function gets a specific myob customer
  // this.getMyobCustomerMapped(this.UID);

// this.getMyobCustomers();

}



  public getMyobContact() {
    this.myobContactService.getMyobContact(this.UID).subscribe(MyobContact => this.myobContact = MyobContact);

    this.getMyobCustomerMapped(this.UID); // test to show the contact mapped works.
  }

  public getAllMyobContacts() {
    console.log('fetching customer api data');
     this.myobContactService.getAllMyobContacts().subscribe(e => this.myobContacts = e);
 //  this.myobContacts_demo = this.myobContactService.getMyobCustomers();
  };

  public getUser() {
    this.userService2.getUser(this.userId).subscribe(user => this.user = user);
  }

  public getAllUsers() {
    this.userService2.getAllUsers().subscribe(users => this.users = users);
  }



  getMyobCode() {
    this._demoService.getMyobCode().subscribe(
      data => { this.myobCode = data;
        this.toastr.success('MYOB handshake: shaken..! SOP we are connected...');

      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );

  }



  // need to work how to map
  /*


 public getAllMyobContacts(): Observable<MyobContact[]> {
    return this.httpService.get<MyobContact[]>(`http://localhost:1050/myob_customers`).pipe(
      map(data => data.map(data => new MyobContact().deserialize(data)))
    );
  }

  */

  // uses demo services but calls to myob
 public getMyobCustomers() {
    this._demoService.getMyobCustomers().subscribe(
      data => { this.myobCustomersDemo = data;
        const res = data[0];
         // https://www.concretepage.com/questions/577
         this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
         // console.log(this.arrCase);
         this.Items = data['Items'] ;

         console.log(this.Items);
        // this.Address = this.Items['Address'];
  // return this.myobCustomers;

  // Map the data top the new model system
 // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));

      },
      err => {
        // this.toastr.error('You need to login to MYOB again, Connection lost!');
        console.error(err);
      },
      // () => console.log('done loading Trace Types')
    );

  }


  public getMyobCustomer(UID){
    return  this._demoService.getMyobCustomer(this.UID).subscribe(
        data => { this.myobCustomer = data;
          let res = data[0];
           this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
           // console.log(this.arrCase);
           this.customerItem = data['Item'] ;
          // console.log(this.customerItem);
          // this.Address = this.Items['Address'];
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
          console.error(err);
        },
        // () => console.log('done loading')
      );
    }



    // the declared vars
    //  myobContactListMapped: MyobContact[];
    getMyobCustomerMapped(UID) {
   return  this._demoService.getMyobCustomerMapped(UID)
      .subscribe((data:any) => {
         console.log(data);
       // many
         // this.myobContactListMapped = data.data;
       //single
         this.myobContactListMapped = data.data;
      });
    }


    refreshGrid() { // refresh the databutton
      // this.getFiles();
      // this.grid.refresh();
    };

    refreshPage() { // refresh the databutton
      // this.getFiles();
      // this.grid.refresh();
    };

       // to router navigate back
       public goBack() {
        this._location.back();
        }



}





